<template>
  <roe-error-message :field="design.employer_other_fixed_or_discretionary">
    <v-select
      name="employer_other_fixed_or_discretionary"
      v-model="design.$model.employer_other_fixed_or_discretionary"
      :options="[
        { code: 2, label: 'Fixed Every Year' },
        { code: 1, label: 'Can Vary From Year to Year' }
      ]"
      :reduce="label => label.code"
      required
    >
    </v-select>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
export default {
  name: "RoeEmployerOtherTypeSelect",
  components: { RoeErrorMessage },
  props: {
    design: Object
  }
};
</script>
